'use client'

import { Text } from '@vinted/web-ui'

import { DigitalProductPassportItemDto } from '@marketplace-web/pro-integrations/pro-integrations-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const HeaderSection = ({ dppItem: { brand } }: { dppItem: DigitalProductPassportItemDto }) => {
  const translate = useTranslate('business.digital_product_passport.header')

  return (
    <section className="digital-product-passport_header-section">
      <Text
        as="span"
        alignment={Text.Alignment.Center}
        text={translate('collab', { brand })}
        testId="digital-product-passport-collab"
      />
      <Text as="h1" alignment={Text.Alignment.Center} text={translate('title')} />
      <Text as="p" alignment={Text.Alignment.Center} text={translate('description')} />
    </section>
  )
}

export default HeaderSection
